"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileCompletenessSection = void 0;
exports.instanceOfProfileCompletenessSection = instanceOfProfileCompletenessSection;
exports.ProfileCompletenessSectionFromJSON = ProfileCompletenessSectionFromJSON;
exports.ProfileCompletenessSectionFromJSONTyped = ProfileCompletenessSectionFromJSONTyped;
exports.ProfileCompletenessSectionToJSON = ProfileCompletenessSectionToJSON;
exports.ProfileCompletenessSectionToJSONTyped = ProfileCompletenessSectionToJSONTyped;
/**
 *
 * @export
 */
exports.ProfileCompletenessSection = {
    GeneralBackgroundCheck: 'generalBackgroundCheck',
    SupplementalBackgroundChecks: 'supplementalBackgroundChecks',
    Contract: 'contract',
    ConfidentialityAgreement: 'confidentialityAgreement',
    DhsBackgroundCheck: 'dhsBackgroundCheck',
    EmrSystems: 'emrSystems',
    Tuberculosis: 'tuberculosis',
    PersonalInformation: 'personalInformation',
    Specialties: 'specialties',
    RegulatoryAssessments: 'regulatoryAssessments',
    Licenses: 'licenses',
    Vaccinations: 'vaccinations',
    VaccinationsReviewed: 'vaccinationsReviewed',
    Certifications: 'certifications',
    CertificationsVerified: 'certificationsVerified',
    Payroll: 'payroll',
    Resume: 'resume'
};
function instanceOfProfileCompletenessSection(value) {
    for (const key in exports.ProfileCompletenessSection) {
        if (Object.prototype.hasOwnProperty.call(exports.ProfileCompletenessSection, key)) {
            if (exports.ProfileCompletenessSection[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ProfileCompletenessSectionFromJSON(json) {
    return ProfileCompletenessSectionFromJSONTyped(json, false);
}
function ProfileCompletenessSectionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ProfileCompletenessSectionToJSON(value) {
    return value;
}
function ProfileCompletenessSectionToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ProfileCompletenessSection.js.map